import React from "react"
import DocHeader from "styleguide/components/doc/DocHeader"
import { Articles, Location } from "../types/docs"

interface Props {
  children: React.ReactNode
  repoName: string
  repoDisplayName: string
  mdxName: string
  currentSlug: string
  categories: string[]
  location: Location
  articles: Articles
}

const DocHeaderPersistent = ({
  children,
  repoName,
  repoDisplayName,
  mdxName,
  currentSlug,
  categories,
  location,
  articles
}: Props) => (
  <>
    <DocHeader
      repoName={repoName}
      repoDisplayName={repoDisplayName}
      mdxName={mdxName}
      currentSlug={currentSlug}
      categories={categories}
      location={location}
      articles={articles}
    />
    {children}
  </>
)

export default DocHeaderPersistent